<template>
  <div class="kpi-card card__container__wrapper">

    <div class="card__container">
      <div class="card__container__main">
        <slot name="title">
          <h1 class="card__container__main__title" v-if="title !== undefined && title !== null">
            {{title}}
          </h1>
        </slot>

        <slot name="subtitle">
          <div class="card__container__main__subtitle" v-if="subtitle !== undefined && subtitle !== null">
            {{subtitle}}
          </div>
        </slot>

        <div class="card__container__main__description">
          <slot name="description">
            <span>{{description}}</span>
          </slot>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: false,
      default: 0
    },
    subtitle: {
      required: false
    },
    description: {
      type: String,
      require: false,
      default: ''
    }
  }
}
</script>

<style lang="scss">

@mixin for-desktop {
  @media (min-width: 766px) {
    @content;
  }
}

@mixin for-desktop-xl {
  @media (min-width: 1336px) {
    @content;
  }
}

$primary-green: #29c4a9;
$primary-dark-gray: #48494B;
$primary-light-gray: #6E6E6E;
$primary-red: #c42940;
$primary-yellow: #c49d29;
$primary-black: rgb(48, 48, 48);
$card-color: #F0F0F0;

.kpi-card {

  & .card__container {

    background-color: $card-color;
    padding: 1rem 1rem 0.25rem 1rem;

    @include for-desktop {
      height: 100%;
    }

    height: auto;
    margin: 2% 0%;

    &__main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      text-align: center;

      &__title {
        margin-top: 1.5rem;
        margin-bottom: 0.6rem;
        font-weight: bold;
        color: $primary-dark-gray;
      }

      &__subtitle {
        color: $primary-light-gray;
        margin-bottom: 0.6rem;
        text-transform: uppercase;
      }

      &__description {
        font-size: 0.825rem;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;

        & span {
          font-size: 0.825rem;
          color: $primary-green;
        }
      }
    }
  }
}
</style>
